// import { Link } from 'react-router-dom';
// import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import image1 from '../../images/clients/1.png';
import image2 from '../../images/clients/2.png';
import image3 from '../../images/clients/3.png';
import image4 from '../../images/clients/4.png';

const Clients = [
    {
        id: 1,
        logo: image1,
        name: "Client 1"
    },
    {
        id: 2,
        logo: image2,
        name: "Client 2"
    },
    {
        id: 3,
        logo: image3,
        name: "Client 3"
    },
    {
        id: 4,
        logo: image4,
        name: "Client 4"
    }
   
];
export default Clients;
